import SafetyEvaluationRoutes from './routes'
import 'windi.css'

export default {
  // name version 必须为字面常量
  name: 'safety-evaluation',
  title: '安全评价',
  version: '0.1.4',
  description: '安全评价',
  routes: SafetyEvaluationRoutes, // 导出相关路由
  sysRoutes: [], // ·系统管理· 下的路由，可以为空
  dependencies: {
    // 这里记录本模块所依赖接口
    apis: [],
  },
}
